<template>
  <div class="calendar" v-loading="loading">
    <div class="header">
      <div class="header_left">
        <div class="header_left_top">
          <div class="header_doctor_name">
            <span>{{ doctorName }}</span>
            <span v-if="departments.length > 0">（{{ departments.map(v => v.departmentName).join('、') }}）</span>
          </div>
          <div v-if="haveSchedule" class="header_type">
            <el-radio-group class="header_type_group" v-model="type">
              <el-radio label="">
                <div class="header_type_item">
                  <span class="header_type_text">全部班次</span>
                </div>
              </el-radio>
              <el-radio label="1">
                <div class="header_type_item">
                  <span class="header_type_text">仅看门诊</span>
                  <span class="header_type_icon icon_blue"></span>
                </div>
              </el-radio>
              <el-radio label="2">
                <div class="header_type_item">
                  <span class="header_type_text">仅看理疗执行</span>
                  <span class="header_type_icon icon_green"></span>
                </div>
              </el-radio>
            </el-radio-group>
          </div>
        </div>
        <div class="header_left_tips">
          <span>本月应坐诊{{ visitCount.shouldVisitCount || 0 }}次</span>
          <!-- 当月​及未来月份不展示 -->
          <span v-if="currentDate < new Date().Format('yyyy-MM')">，实际坐诊{{ visitCount.actualVisitCount || 0 }}次</span>
        </div>
      </div>
      <div class="header_right">
        <div v-if="haveSchedule" class="header_right_operate header_right_rlue" @click="toScheduleRules">编辑周排班规则</div>
        <div v-if="haveSchedule" class="header_right_operate header_right_stop" @click="openStopSetting">停诊设置</div>
        <div class="header_right_operate header_right_date">
          <span class="el-icon-arrow-left header_date_icon" @click="switchDate('prev')"></span>
          <span class="header_date_text">{{ currentDate }}</span>
          <span class="el-icon-arrow-right header_date_icon" @click="switchDate('next')"></span>
        </div>
      </div>
    </div>
    <div class="info">
      <div v-if="!haveSchedule" class="info_notHave">
        <div class="notHave_operate">
          <el-button type="primary" class="notHave_operate_toRules" @click="toScheduleRules">创建周排班规则</el-button>
          <el-button class="notHave_operate_toSchedule" @click="toScheduleCalendar">创建日排班</el-button>
        </div>
      </div>
      <table class="info_table">
        <thead>
          <tr class="table_thead_tr">
            <th class="table_thead_th">周一</th>
            <th class="table_thead_th">周二</th>
            <th class="table_thead_th">周三</th>
            <th class="table_thead_th">周四</th>
            <th class="table_thead_th">周五</th>
            <th class="table_thead_th">周六</th>
            <th class="table_thead_th">周日</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(week, weekIndex) in dateMap.list" :key="weekIndex" class="table_tbody_tr">
            <td v-for="(day, dayIndex) in week" :key="dayIndex" class="table_tbody_td">
              <div class="table_item">
                <div class="table_item_header">
                  <div :class="{ table_item_header_day: true, expire: day.date < nowDate || day.date > lastDate, today: day.date === nowDate }">{{ day.date === nowDate ? '今' : day.day }}</div>
                  <div v-if="suspendDateMap[day.date]" class="table_item_header_stop">{{ suspendDateText(day.date) }}</div>
                </div>
                <div class="table_item_schedule">
                  <ScheduleCard
                    v-for="schedule in scheduleMap[day.date]"
                    :key="schedule.schedulingItemId"
                    v-show="type === '' || type === schedule.ruleType"
                    class="schedule_card"
                    :info="schedule"
                    @schedulePause="schedulePause"
                    @scheduleEdit="scheduleEdit"
                    @scheduleStop="scheduleStop"
                    @scheduleDelete="scheduleDelete">
                  </ScheduleCard>
                </div>
              </div>
              <div class="table_item_footer">
                <div v-if="!(day.date < nowDate || day.date > lastDate)" class="table_item_footer_info">
                  <div class="table_item_footer_btn" @click="scheduleEdit({ type: 'add', ruleType: '1', schedulingItemDateTime: { schedulingTime: day.date } })">
                    <span class="el-icon-plus table_item_footer_btn_icon"></span>
                    <span class="table_item_footer_btn_text">门诊排班</span>
                  </div>
                  <div class="table_item_footer_btn" @click="scheduleEdit({ type: 'add', ruleType: '2', schedulingItemDateTime: { schedulingTime: day.date } })">
                    <span class="el-icon-plus table_item_footer_btn_icon"></span>
                    <span class="table_item_footer_btn_text">理疗执行</span>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <StopSetting ref="stopSetting" @batchStop="batchStop" @deleteScheduleSuspend="deleteScheduleSuspend"></StopSetting>
    <BatchStop ref="batchStop" @submit="batchStopCheck"></BatchStop>
    <ScheduleEditDefault ref="scheduleEditDefault" application="scheduling" @submit="editSubmit"></ScheduleEditDefault>
    <ScheduleEditPhysio ref="scheduleEditPhysio" application="scheduling" @submit="editSubmit"></ScheduleEditPhysio>
    <ScheduleRulesPrompt ref="scheduleRulesPrompt" @submit="schedulePromptSubmit"></ScheduleRulesPrompt>
  </div>
</template>

<script>
  import StopSetting from './stopSetting.vue'
  import BatchStop from './batchStop.vue'
  import ScheduleCard from './scheduleCard.vue'
  import ScheduleEditDefault from './scheduleEdit_default.vue'
  import ScheduleEditPhysio from './scheduleEdit_physio.vue'
  import ScheduleRulesPrompt from './scheduleRulesPrompt.vue'

  import req from '@/utils/request'

  import {
    getScheduleMap,
    postDefaultScheduleList,
    putDefaultScheduleOne,
    deleteCheckSchedule,
    deleteDefaultSchedule,
    postPhysioScheduleList,
    putPhysioScheduleOne,
    deletePhysioSchedule,
    startStopSchedule,
    cancelStopSchedule,
    batchStopSchedule,
    getDoctorScheduleHistory,
    getScheduleSuspendList,
    getDoctorMonthAllotBedNumber
  } from '@/api/schedule'

  const timeTypeMap = {
    '1': '上午',
    '2': '中午',
    '3': '下午',
    '4': '晚上'
  }

  export default {
    name: 'calendar',
    components: {
      StopSetting,
      BatchStop,
      ScheduleCard,
      ScheduleEditDefault,
      ScheduleEditPhysio,
      ScheduleRulesPrompt
    },
    props: {
      doctorId: [Number, String],
      doctorName: [Number, String]
    },
    data() {
      return {
        loading: false,
        deptId: '',
        deptName: '',
        departments: [],
        haveSchedule: true,
        nowDate: '',
        lastDate: '',
        type: '',
        currentDate: '',
        dateMap: {
          startDate: '',
          endDate: '',
          list: []
        },
        suspendDateMap: {},
        scheduleMap: {},
        visitCount:{}
      };
    },
    created() {},
    mounted() {},
    computed: {
      suspendDateText () {
        return (date) => {
          const isAll = ['1', '2', '3', '4'].every(type => { return this.suspendDateMap[date].length === 0 || this.suspendDateMap[date].includes(type) })
          return (isAll ? '全天' : this.suspendDateMap[date].map(type => { return timeTypeMap[type] }).join('、')) + '时段已设置停诊'
        }
      }
    },
    methods: {
      init (type, date) {
        const deptInfo = sessionStorage.getItem('deptInfo') && JSON.parse(sessionStorage.getItem('deptInfo'))
        this.deptId = deptInfo.deptId || ''
        this.deptName = deptInfo.deptName || ''

        this.nowDate = new Date().Format('yyyy-MM-dd')
        this.lastDate = new Date(+new Date() + 59 * (24 * 60 * 60 * 1000)).Format('yyyy-MM-dd')

        this.type = type || ''
        this.currentDate = date || new Date().Format('yyyy-MM')
        this.getInfo()
      },
      async getInfo () {
        await this.getDateList()
        await this.getDoctorHistory()
        this.getSuspendList()
        this.getSchedule()
        this.getDepartMents()
        this.getDoctorMonthAllotBedNumber()
      },
      getDateList () {
        const currentFirstDate = new Date(this.currentDate)
        const currentFirstDay = currentFirstDate.getDay() || 7

        const currentLastDate = new Date(new Date(this.currentDate).setMonth(new Date(this.currentDate).getMonth() + 1, 0))
        const currentLastDay = currentLastDate.getDay() || 7

        const firstTime = currentFirstDate.getTime() - ((currentFirstDay - 1) * 24 * 60 * 60 * 1000)
        const lastTime = currentLastDate.getTime() + ((7 - currentLastDay) * 24 * 60 * 60 * 1000)

        const days = ((lastTime - firstTime) / (24 * 60 * 60 * 1000)) + 1

        const weeks = new Array(days / 7).fill().map(() => [])

        for (let i = 0; i < days; i++) {
          const time = firstTime + i * 24 * 60 * 60 * 1000
          const date = new Date(time).Format('yyyy-MM-dd')
          const day = new Date(time).Format('d')
          weeks[Math.floor(i / 7)].push({
            date: date,
            day: day
          })
        }

        this.dateMap.startDate = new Date(firstTime).Format('yyyy-MM-dd')
        this.dateMap.endDate = new Date(lastTime).Format('yyyy-MM-dd')
        this.dateMap.list = weeks
      },
      async getDoctorHistory () {
        this.loading = true
        const res = await getDoctorScheduleHistory({
          deptId: window.sessionStorage.getItem('deptId'),
          doctorId: this.doctorId
        })
        this.loading = false
        if (res.code === 200) {
          this.haveSchedule = res.data
        }
      },
      async getSuspendList () {
        this.loading = true
        const res = await getScheduleSuspendList({
          deptId: window.sessionStorage.getItem('deptId'),
          doctorId: this.doctorId
        })
        this.loading = false
        if (res.code === 200) {
          let suspendMap = {}
          res.data && res.data.forEach(v => {
            const startDate = new Date(v.startTime).Format('yyyy-MM-dd')
            const stopDate = new Date(v.stopTime).Format('yyyy-MM-dd')

            let currentDate = startDate

            while (currentDate <= stopDate) {
              suspendMap[currentDate] = suspendMap[currentDate] || []
              suspendMap[currentDate] = suspendMap[currentDate].concat(v.timeTypes || [])
              suspendMap[currentDate] = [...new Set(suspendMap[currentDate])]
              currentDate = new Date(new Date(currentDate).setDate(new Date(currentDate).getDate() + 1)).Format('yyyy-MM-dd')
            }
          })
          this.suspendDateMap = suspendMap
        }
      },
      async getSchedule() {
        this.loading = true
        const res = await getScheduleMap({
          deptId: window.sessionStorage.getItem('deptId'),
          doctorId: this.doctorId,
          startTime: this.dateMap.startDate,
          endTime: this.dateMap.endDate
        })
        this.loading = false
        if (res.code === 200) {
          this.scheduleMap = res.data
        } else {
          this.scheduleMap = {}
        }
      },
      async getDepartMents () {
        const res = await req.get('/system/department/doctor/departments', { doctorId: this.doctorId })
        if (res.code === 200) {
          this.departments = res.data
        }
      },
      switchDate (type) {
        const date = new Date(this.currentDate)
        switch (type) {
          case 'prev':
            const startDate = new Date(new Date(this.nowDate).setMonth(new Date(this.nowDate).getMonth() - 1)).Format('yyyy-MM')
            if (this.currentDate > startDate) {
              date.setMonth(date.getMonth() - 1)
            }
            break
          case 'next':
            const lastTime = new Date().getTime() + 60 * (24 * 60 * 60 * 1000)
            const lastDate = new Date(lastTime).Format('yyyy-MM')
            if (this.currentDate < lastDate) {
              date.setMonth(date.getMonth() + 1)
            }
            break
        }
        if (this.currentDate !== date.Format('yyyy-MM')) {
          this.currentDate = date.Format('yyyy-MM')
          this.getInfo()
        }
      },
      toScheduleRules () {
        const scheduleInfo = {
          type: this.type,
          currentDate: this.currentDate
        }
        this.$emit('cache', JSON.parse(JSON.stringify(scheduleInfo)))
        this.$router.push(`/doctormanage/scheduleRules/${this.doctorId}?doctorName=${this.doctorName}`)
      },
      toScheduleCalendar () {
        this.haveSchedule = true
      },
      openStopSetting () {
        this.$refs['stopSetting'].open(this.doctorId)
      },
      deleteScheduleSuspend () {
        this.getSuspendList()
        this.getSchedule()
      },
      batchStop () {
        this.$refs['batchStop'].open()
      },
      async batchStopCheck (info) {
        const params = {
          dept: { deptId: this.deptId, deptName: this.deptName },
          doctor: { doctorId: this.doctorId, doctorName: this.doctorName },
          startTime: info.startTime,
          stopTime: info.stopTime,
          timeTypes: info.timeTypes,
          status: '0'
        }
        const res = await req.post('/scheduling-suspend-medical/rule-registered-scheduling', params)
        if (res.code === 200) {
          if (res.data && res.data.length > 0) {
            let listText = ''

            res.data.forEach((v, i) => {
              listText = listText + `${i > 0 ? '\n' : ''}·${v.schedulingTime} ${v.timeType} ${v.timeQuantum}`
            })

            const h = this.$createElement;
            this.$msgbox({
              title: '提示',
              message: h('div', { style: 'max-height: 400px; overflow-x: hidden; overflow-y: auto;' }, [
                h('div', { style: 'line-height: 20px; font-weight: 600; font-size: 14px;' }, '待停诊班次包含已挂号源，是否确定立即关闭挂号通道，保留已挂号记录待人工处理改签或退号？'),
                h('div', { style: 'margin: 6px 0 0 0; line-height: 20px; font-size: 14px' }, '含已挂号源班次：'),
                h('div', { style: 'margin: 6px 0 0 0; line-height: 20px; white-space: pre-line; font-size: 14px' }, listText),
              ]),
              showCancelButton: true,
              confirmButtonText: '确定',
              cancelButtonText: '取消'
            }).then(() => {
              this.batchStopSubmit(params)
            }).catch(() => {})
          } else {
            this.batchStopSubmit(params)
          }
        }
      },
      async batchStopSubmit (params) {
        const res = await batchStopSchedule(params)
        if (res.code === 200) {
          if (res.data.code === 200) {
            this.$message.success('批量停诊成功')
            this.$refs['batchStop'].close()
            this.$refs['stopSetting'].getList()
            this.getSuspendList()
            this.getSchedule()
          } else {
            this.$message.error(res.data.message)
          }
        }
      },
      schedulePause () {
        this.getSchedule()
      },
      scheduleEdit (info) {
        if (info.ruleType === '1') {
          this.$refs.scheduleEditDefault.init(info)
        } else {
          this.$refs.scheduleEditPhysio.init(info)
        }
      },
      schedulePromptSubmit () {
        this.getDoctorHistory()
        this.getSuspendList()
        this.getSchedule()
      },
      async editSubmit (info) {
        if (info.ruleType === '1') {
          this.$refs['scheduleEditDefault'].setLoading(true)
        } else {
          this.$refs['scheduleEditPhysio'].setLoading(true)
        }
        let list = []
        let res = null
        if (info.type === 'add') {
          info.schedulingTimes && info.schedulingTimes.forEach(scheduling => {
            list.push({
              schedulingItemId: info.schedulingItemId,
              dept: { deptId: this.deptId, deptName: this.deptName },
              doctor: { doctorId: this.doctorId, doctorName: this.doctorName },
              clinic: { clinicId: info.clinicId, clinicName: info.clinicName },
              schedulingItemDateTime: { 
                schedulingTime: scheduling,
                timeType: info.timeType,
                appointmentStartTime: `${info.appointmentStartTime}:00`,
                appointmentEndTime: `${info.appointmentEndTime}:00`,
                timeQuantumCode: info.timeQuantumCode,
                releaseDay: info.releaseDay,
                releasePointTime: `${info.releasePointTime}:00`
              },
              generalVo: info.generalVo,
              physicalVo: info.physicalVo,
              contributingVo: info.contributingVo,
              freeVo: info.freeVo,
              transferVo: info.transferVo,
              ruleType: info.ruleType,
              bedIndependenceNumber: info.bedIndependenceNumber,
              delFlag: '0',
              increaseSchedulingItem:info.increaseSchedulingItem
            })
          })
          if (info.ruleType === '1') {
            res = await postDefaultScheduleList({ schedulingItemNewList: list })
          } else {
            res = await postPhysioScheduleList({ schedulingItemNewList: list })
          }
        } else {
          const reqObj = {
            schedulingItemId: info.schedulingItemId,
            dept: { deptId: this.deptId, deptName: this.deptName },
            doctor: { doctorId: this.doctorId, doctorName: this.doctorName },
            clinic: { clinicId: info.clinicId, clinicName: info.clinicName },
            schedulingItemDateTime: { 
              schedulingTime: info.schedulingTime,
              timeType: info.timeType,
              appointmentStartTime: `${info.appointmentStartTime}:00`,
              appointmentEndTime: `${info.appointmentEndTime}:00`,
              timeQuantumCode: info.timeQuantumCode,
              releaseDay: info.releaseDay,
              releasePointTime: `${info.releasePointTime}:00`
            },
            generalVo: info.generalVo || null,
            physicalVo: info.physicalVo || null,
            contributingVo: info.contributingVo || null,
            freeVo: info.freeVo || null,
            transferVo: info.transferVo || null,
            ruleType: info.ruleType,
            bedIndependenceNumber: info.bedIndependenceNumber,
            delFlag: '0',
            increaseSchedulingItem:info.increaseSchedulingItem
          }
          if (info.ruleType === '1') {
            res = await putDefaultScheduleOne(reqObj)
          } else {
            res = await putPhysioScheduleOne(reqObj)
          }
        }

        if (info.ruleType === '1') {
          this.$refs['scheduleEditDefault'].setLoading(false)
        } else {
          this.$refs['scheduleEditPhysio'].setLoading(false)
        }

        if (res.code === 200) {
          if (res.data.code === 200) {
            this.$message.success(`${info.type === 'add' ? '新增' : '修改'}${info.ruleType === '1' ? '门诊' : '理疗执行'}排班成功`)
            if (info.ruleType === '1') {
              this.$refs['scheduleEditDefault'].close()
            } else {
              this.$refs['scheduleEditPhysio'].close()
            }
            this.getDoctorHistory()
            this.getSuspendList()
            this.getSchedule()
          } else {
            if (res.data.errorType === '1') {
              this.$refs['scheduleRulesPrompt'].open({
                title: '修改失败',
                tips: '',
                label: '异常数据',
                list: res.data.data,
                isLeave: false
              })
            } else {
              this.$message({
                message: res.data.message,
                type: 'error',
                customClass: 'multiline-message'
              })
            }
          }
        }
      },
      scheduleStop (info) {
        if (!info.isStop) {
          let message = ''
          if (info.isRegistration) {
            if (info.ruleType === '1') {
              message = '该排班已有患者挂号，停诊该排班，系统将保留已挂号源，请及时为患者改签或退号！'
            } else {
              message = '该排班已有患者预约，停诊该排班，请及时联系患者！'
            }
          } else {
            message = '确定停诊该排班？'
          }
          this.$confirm(message, '停止排班？', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            customClass: 'schedule_confirm'
          }).then(async () => {
            const res = await startStopSchedule({ id: info.schedulingItemId })
            if (res.code === 200) {
              this.$message.success('停诊成功')
              this.getSuspendList()
              this.getSchedule()
            }
          }).catch(() => {})
        } else {
          this.$confirm('取消停诊后该排班将恢复正常，确定取消？', '取消停诊？', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            customClass: 'schedule_confirm'
          }).then(async () => {
            const res = await cancelStopSchedule({ id: info.schedulingItemId })
            if (res.code === 200) {
              if (res.data.code === 200) {
                this.$message.success('取消停诊成功')
              } else {
                this.$confirm(res.data.message, '取消停诊失败', {
                  confirmButtonText: '知道了',
                  showCancelButton: false,
                  customClass: 'schedule_confirm'
                }).then(() => {}).catch(() => {})
              }
              this.getSuspendList()
              this.getSchedule()
            }
          }).catch(() => {})
        }
      },
      async scheduleDelete (info) {
        const checkRes = await deleteCheckSchedule({ sid: info.schedulingItemId })
        if (checkRes.code === 200) {
          if (checkRes.data) { 
            this.$confirm('待删除班次包含已挂号源，不允许删除，是否先设置为停诊？', '删除排班？', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
              customClass: 'schedule_confirm',
              closeOnClickModal: false,
              closeOnPressEscape: false
            }).then(async () => { 
              const res = await startStopSchedule({ id: info.schedulingItemId })
              if (res.code === 200) {
                this.$message.success('停诊成功')
                this.getSuspendList()
                this.getSchedule()
              }
            }).catch(() => {
              this.getSuspendList()
              this.getSchedule()
            })
            return
          }
        }
        this.$confirm('删除排班后不可恢复，确定删除？', '删除排班？', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          customClass: 'schedule_confirm',
          closeOnClickModal: false,
          closeOnPressEscape: false
        }).then(async () => { 
          let res = null
          if (info.ruleType === '1') {
            res = await deleteDefaultSchedule({id: info.schedulingItemId})
          } else {
            res = await deletePhysioSchedule({id: info.schedulingItemId})
          }
          if (res.code === 200) {
            this.$message.success('删除成功')
            this.getSuspendList()
            this.getSchedule()
          }
        }).catch(() => {})
      },
      // 获取医生本月应坐诊次数
      async getDoctorMonthAllotBedNumber() {
        const res = await getDoctorMonthAllotBedNumber({ doctorId: this.doctorId,date: this.currentDate })
        if (res.code === 200) {
          this.visitCount = res.data
        } else {
          this.visitCount = {}
        }
      }
    }
  };
</script>

<style lang="less" scoped>
  .calendar {
    width: 100%;
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #FFFFFF;
  }

  .header_left {
    
  }
  
  .header_left_top {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .header_left_tips {
    font-size: 13px;
    color: #eb6526;
    margin-top: 8px;
  }

  .header_doctor_name {
    font-weight: bold;
    font-size: 18px;
    color: #000000;
  }

  .header_type {
    margin: 0 0 0 32px;
  }

  .header_type_group {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .header_type_group /deep/ .el-radio {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-right: 24px;
  }

  .header_type_group /deep/ .el-radio__label {
    padding-left: 3px;
  }

  .header_type_item {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .header_type_text {
    font-size: 14px;
    color: #606266;
  }

  .header_type_icon {
    margin: 0 0 0 4px;
    width: 10px;
    height: 10px;
    border-radius: 2px;
  }

  .header_type_icon.icon_blue {
    background-color: #1890FF;
  }

  .header_type_icon.icon_green {
    background-color: #29C01B;
  }

  .header_right {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .header_right_operate+.header_right_operate {
    margin: 0 0 0 16px;
  }

  .header_right_rlue {
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 12px;
    height: 36px;
    font-size: 14px;
    color: #FFFFFF;
    background-color: #1890FF;
    border-radius: 4px;
    cursor: pointer;
  }

  .header_right_stop {
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 12px;
    height: 36px;
    font-size: 14px;
    color: #1F2329;
    border: 1px solid #D3D3D5;
    border-radius: 4px;
    cursor: pointer;
  }

  .header_right_date {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .header_date_icon {
    font-size: 14px;
    color: #667182;
    cursor: pointer;
  }

  .header_date_text {
    margin: 0 8px;
    font-weight: bold;
    font-size: 16px;
    color: #000000;
  }

  .info {
    position: relative;
    z-index: 1;
    margin: 16px 0 0 0;
    width: 100%;
  }

  .info_notHave {
    position: absolute;
    z-index: 2;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    background-color: rgba(255,255,255,0.8);
    overflow: hidden;
  }

  .notHave_operate_toRules {
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 12px;
    height: 40px;
    font-size: 14px;
    border-radius: 4px;
    cursor: pointer;
  }

  .notHave_operate_toSchedule {
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 0 0 16px;
    padding: 0 12px;
    height: 40px;
    font-size: 14px;
    border: 1px solid #D3D3D5;
    border-radius: 4px;
    cursor: pointer;
  }

  .notHave_operate {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 240px auto 0;
  }

  .info_table {
    width: 100%;
    border: 1px solid #E0E0E0;
    border-radius: 4px;
    table-layout: fixed;
  }

  .table_thead_tr {
    width: 100%;
    height: 36px;
    border-bottom: 1px solid #E0E0E0;
  }

  .table_thead_th {
    width: calc(100% / 7);
    line-height: 36px;
  }

  .table_thead_th+.table_thead_th {
    border-left: 1px solid #E0E0E0;
  }

  .table_tbody_tr {
    width: 100%;
  }

  .table_tbody_tr+.table_tbody_tr {
    border-top: 1px solid #E0E0E0;
  }

  .table_tbody_td {
    position: relative;
    z-index: 1;
    width: calc(100% / 7);
    background-color: #FFFFFF;
    vertical-align: top;
  }

  .table_tbody_td:hover {
    background-color: #F7F8F9;
  }

  .table_item {
    box-sizing: border-box;
    padding: 4px;
    width: 100%;
    min-height: 114px;
  }

  .table_item_header {
    width: 100%;
  }

  .table_item_header_day {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 24px;
    height: 24px;
    font-weight: bold;
    font-size: 14px;
    color: #000000;
    border-radius: 50%;
    overflow: hidden;
  }

  .table_item_header_day.expire {
    color: #A4AFBA;
  }

  .table_item_header_day.today {
    color: #FFFFFF;
    background-color: #1890FF;
  }

  .table_item_header_stop {
    margin: 6px 0 0 0;
    width: 100%;
    line-height: 24px;
    text-align: center;
    font-size: 12px;
    color: #667182;
    background-color: #EDEDED;
    border-radius: 4px;
  }

  .table_item_schedule {
    margin: 6px 0 0 0;
    width: 100%;
  }

  .schedule_card+.schedule_card {
    margin: 8px 0 0 0;
  }

  .table_item_footer {
    margin: 16px 0 0 0;
    width: 100%;
    height: 32px;
  }

  .table_item_footer_info {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    position: absolute;
    z-index: 2;
    left: 0px;
    bottom: 0px;
    width: 100%;
    height: 32px;
    visibility: hidden;
  }

  .table_tbody_td:hover .table_item_footer_info {
    visibility: visible;
  }

  .table_item_footer_btn {
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 50%;
    height: 100%;
    background-color: #FFFFFF;
    border-top: 1px solid #E0E0E0;
    border-left: 1px solid #E0E0E0;
    border-right: 1px solid #E0E0E0;
    cursor: pointer;
  }

  .table_item_footer_btn+.table_item_footer_btn {
    border-left: none;
  }

  .table_item_footer_btn_icon {
    font-size: 14px;
    color: #D3D3D5;
  }

  .table_item_footer_btn_text {
    margin: 0 0 0 4px;
    font-size: 14px;
    color: #667182;
  }
</style>

<style>
  .schedule_confirm .el-message-box__btns .el-button {
    padding: 8px 12px;
    font-size: 14px;
    border-radius: 2px;
  }

  .multiline-message {
    white-space: pre-line;
  }
</style>
